import { render, staticRenderFns } from "./domaine-terres-dorees.vue?vue&type=template&id=d5acbb9a&scoped=true"
import script from "./domaine-terres-dorees.vue?vue&type=script&lang=js"
export * from "./domaine-terres-dorees.vue?vue&type=script&lang=js"
import style0 from "./domaine-terres-dorees.vue?vue&type=style&index=0&id=d5acbb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5acbb9a",
  null
  
)

export default component.exports